var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUsuariosActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-perfil-active",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:#5e4394}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_880",
    d: "M0 0h23v23H0z",
    className: "cls-1",
    "data-name": "Rect\\xE1ngulo 880"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1856",
    d: "M18.9 4.1a10.465 10.465 0 1 0 0 14.8 10.442 10.442 0 0 0 0-14.8zm1.3 7.4a8.728 8.728 0 0 1-8.8 8.7 8.75 8.75 0 1 1 0-17.5 8.878 8.878 0 0 1 8.8 8.8z",
    className: "cls-2",
    "data-name": "Trazado 1856"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "ic_perm_identity_24px",
    d: "M11.5 4.9a3.691 3.691 0 0 0-3.7 3.7 3.63 3.63 0 0 0 3.7 3.7 3.63 3.63 0 0 0 3.7-3.7 3.691 3.691 0 0 0-3.7-3.7zm0 8.2c-2.5 0-7.4 1.2-7.4 3.7v.6s3.7 3.5 7.4 3.5 7.4-3.5 7.4-3.5v-.6c0-2.4-4.9-3.7-7.4-3.7z",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsuariosActive);
export default __webpack_public_path__ + "static/media/ic-usuarios-active.8a060c944b30892aeeaf598e64009b03.svg";
export { ForwardRef as ReactComponent };